import angular from 'angular';
import Icon from './icon';

export default angular.module('cui.graphics', [
    Icon
])

.name;
